<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6" v-if="!item['@id']">
          <v-file-input
            v-model="item.file"
            accept=".stl"
            :error-messages="fileErrors"
            :label="$t('global.fileinput')"
            required
            show-size
          ></v-file-input>
        </v-col>
        <v-col cols="12" sm="6" md="6">

        </v-col>

      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.name"
            :error-messages="nameErrors"
            :label="$t('global.name')"
            required
            @input="$v.item.name.$touch()"
            @blur="$v.item.name.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.namefr"
            :error-messages="namefrErrors"
            :label="$t('global.namefr')"
            required
            @input="$v.item.namefr.$touch()"
            @blur="$v.item.namefr.$touch()"
          />
        </v-col>

      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6" >
          <v-combobox
            v-if="designfiletypeItems"
            v-model="item.type"
            :items="designfiletypeItems"
            :error-messages="typeErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('designfile.type')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6" >
          <v-text-field
            v-model="item.author"
            :error-messages="authorErrors"
            :label="$t('designfile.author')"
            required
            @input="$v.item.author.$touch()"
            @blur="$v.item.author.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.license"
            :error-messages="licenseErrors"
            :label="$t('designfile.license')"
            required
            @input="$v.item.license.$touch()"
            @blur="$v.item.license.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6" >
          <p>{{ $t('designfile.licensehelpchoice') }}</p>

        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <v-textarea
            v-model="item.description"
            :error-messages="descriptionErrors"
            :label="$t('designfile.description')"
            @input="$v.item.description.$touch()"
            @blur="$v.item.description.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <v-textarea
            v-model="item.descriptionfr"
            :error-messages="descriptionfrErrors"
            :label="$t('designfile.descriptionfr')"
            @input="$v.item.descriptionfr.$touch()"
            @blur="$v.item.descriptionfr.$touch()"
          />
        </v-col>
      </v-row>
    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import { maxsizefile } from '../../utils/files';

export default {
  name: 'DesignFileForm',
  mixins: [validationMixin],
  components: {
    Loading
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    this.designfiletypeGetSelectItems();
  },
  data() {
    return {
        file: null,
        name: null,
        namefr: null,
        type: null,
        author: null,
        license: null,
        description: null,
        descriptionfr: null,
    };
  },
  computed: {
      isLoading() {
        return (this.isLoading_designfiletype
         );
      },
      ...mapFields('designfiletype', {
        designfiletypeItems: 'selectItems',
        isLoading_designfiletype : 'isLoading'
      }),
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    nameErrors() {
      const errors = [];

      if (!this.$v.item.name.$dirty) return errors;

      has(this.violations, 'name') && errors.push(this.violations.name);

      !this.$v.item.name.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    namefrErrors() {
      const errors = [];

      if (!this.$v.item.namefr.$dirty) return errors;

      has(this.violations, 'namefr') && errors.push(this.violations.namefr);

      !this.$v.item.namefr.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    descriptionErrors() {
      const errors = [];
      if (!this.$v.item.description.$dirty) return errors;
      has(this.violations, 'description') && errors.push(this.violations.description);
      !this.$v.item.description.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    descriptionfrErrors() {
      const errors = [];
      if (!this.$v.item.descriptionfr.$dirty) return errors;
      has(this.violations, 'descriptionfr') && errors.push(this.violations.descriptionfr);
      !this.$v.item.descriptionfr.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    authorErrors() {
      const errors = [];

      if (!this.$v.item.author.$dirty) return errors;

      has(this.violations, 'author') && errors.push(this.violations.author);

      !this.$v.item.author.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    licenseErrors() {
      const errors = [];

      if (!this.$v.item.license.$dirty) return errors;

      has(this.violations, 'license') && errors.push(this.violations.license);

      !this.$v.item.license.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    fileErrors() {
      const errors = [];

      if (!this.$v.item.file.$dirty) return errors;

      has(this.violations, 'file') && errors.push(this.violations.file);


      !this.$v.item.file.maxsizefile && errors.push(this.$t('global.maxsize'));

      return errors;
    },
    typeErrors() {
      const errors = [];

      if (!this.$v.item.type.$dirty) return errors;

      has(this.violations, 'type') && errors.push(this.violations.type);


      return errors;
    },
    violations() {
      return this.errors || {};
    }
  },
  methods: {
    ...mapActions({
      designfiletypeGetSelectItems: 'designfiletype/fetchSelectItems',

    }),
  },
  validations: {
    item: {
      file: {
        required,
        maxsizefile : maxsizefile(50),
      },
      name: {
        required,
      },
      namefr: {
        required,
      },
      author: {
        required,
      },
      license: {
        required,
      },
      type: {
        required,
      },
      description: {
        required,
      },
      descriptionfr: {
        required,
      },
    }
  }
};
</script>
